import { KiteGrid, KiteGridCell } from '@kite/react-kite';
import React from 'react';
import { InfographicCell, InfographicCellInputs } from './InfographicCell';
import './InfographicRow.scss';

export interface InfographicRowInputs {
    cells: InfographicCellInputs[];
    title?: string;
}

export const InfographicRow = ({
    inputs,
}: {
    inputs: InfographicRowInputs;
}) => {
    return (
        <section className="kite-container paragraph__infographic_row">
            {!!inputs.title && <h2>{inputs.title}</h2>}
            <KiteGrid noGutters={false}>
                {inputs.cells.map((cell, idx) => (
                    <KiteGridCell key={idx} col={cell.col}>
                        <InfographicCell inputs={cell} />
                    </KiteGridCell>
                ))}
            </KiteGrid>
        </section>
    );
};
